import { render, staticRenderFns } from "./NavigationOutbox.vue?vue&type=template&id=51f8f325&scoped=true"
import script from "./NavigationOutbox.vue?vue&type=script&lang=js"
export * from "./NavigationOutbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationOutbox.vue?vue&type=style&index=0&id=51f8f325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8f325",
  null
  
)

export default component.exports